import { computed } from 'vue';

import useAuth from '@/composables/useAuth';

export default function useApiIntegrationCreateGate() {
  const { hasPermission } = useAuth();

  const canWrite = computed(() => hasPermission('manage:oauth-applications'));

  const createDisabledReason = computed(() =>
    canWrite.value ? undefined : 'Your role cannot create API integrations.',
  );

  return { canWrite, createDisabledReason };
}
